import { __rest } from "tslib";
import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";
import { cn } from "../../lib/utils";
/**
 * @example
 *
 * ```jsx
 * import { Progress } from "@skve/components"
 *
 * function Demo() {
 *   const [progress, setProgress] = React.useState(13)
 *
 *   React.useEffect(() => {
 *     const timer = setTimeout(() => setProgress(66), 500)
 *     return () => clearTimeout(timer)
 *   }, [])
 *
 *   return <Progress value={progress} className="w-[60%]" />
 * }
 * ```
 */
const Progress = React.forwardRef((_a, ref) => {
    var { className, indicatorClassName, value } = _a, props = __rest(_a, ["className", "indicatorClassName", "value"]);
    return (React.createElement(ProgressPrimitive.Root, Object.assign({ ref: ref, className: cn("relative h-4 w-full overflow-hidden rounded-full bg-secondary", className) }, props),
        React.createElement(ProgressPrimitive.Indicator, { className: cn("h-full w-full flex-1 bg-primary transition-all", indicatorClassName), style: { transform: `translateX(-${100 - (value || 0)}%)` } })));
});
Progress.displayName = ProgressPrimitive.Root.displayName;
export { Progress };
//# sourceMappingURL=progress.js.map